import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { LanguageProvider } from "@/context/LanguageContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import EmailPopup from "@/components/EmailPopup";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import Homepage from "@/pages/Homepage";
import About from "@/pages/About";
import Programs from "@/pages/Programs";
// TEMPORARILY HIDDEN - Coffee page hidden per user request, restore when ready
import CoffeePage from "@/pages/CoffeePage";
import DonatePage from "@/pages/DonatePage";
import StoriesPage from "@/pages/StoriesPage";
import GetInvolvedPage from "@/pages/GetInvolvedPage";
import AdminPage from "@/pages/AdminPage";
import HeroesPage from "@/pages/HeroesPage";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

// Wrapper component to conditionally render Navbar/Footer
const AppContent = () => {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin');

  return (
    <div className="App min-h-screen flex flex-col">
      <ScrollToTop />
      <AnalyticsTracker />
      {!isAdminPage && <Navbar />}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/about" element={<About />} />
          <Route path="/programs" element={<Programs />} />
          {/* TEMPORARILY UNHIDDEN FOR PREVIEW ONLY - will re-hide before deploy */}
          <Route path="/coffee" element={<CoffeePage />} />
          <Route path="/donate" element={<DonatePage />} />
          <Route path="/media" element={<StoriesPage />} />
          <Route path="/stories" element={<Navigate to="/media" replace />} />
          <Route path="/heros" element={<HeroesPage />} />
          <Route path="/heroes" element={<Navigate to="/heros" replace />} />
          <Route path="/get-involved" element={<GetInvolvedPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/videos" element={<AdminPage />} />
        </Routes>
      </main>
      {!isAdminPage && <Footer />}
      {!isAdminPage && <EmailPopup />}
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
